/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Editorial_AlternativesInputs */

const en_directory_detail_editorial_alternatives = /** @type {(inputs: Directory_Detail_Editorial_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Different paths for a similar job`)
};

const zh_directory_detail_editorial_alternatives = /** @type {(inputs: Directory_Detail_Editorial_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相近任务的不同路径`)
};

/**
* | output |
* | --- |
* | "Different paths for a similar job" |
*
* @param {Directory_Detail_Editorial_AlternativesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_editorial_alternatives = /** @type {((inputs?: Directory_Detail_Editorial_AlternativesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Editorial_AlternativesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_editorial_alternatives(inputs)
	return zh_directory_detail_editorial_alternatives(inputs)
});
export { directory_detail_editorial_alternatives as "directory.detail.editorial_alternatives" }